import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { getMessage } from 'util/locale';
import propTypes from 'prop-types';
// components
import { Modal } from '@tcc/crate';

export const DriveModal = (props) => {
  const baseString = 'vra-export-selector';
  const { open, toggleDriveModal, selectedDevice, selectedFormat, exportSelectorParams } = props;
  const {
    scriptType = 'fertility-fall',
    primaryOnly,
    scripts
  } = exportSelectorParams;
  const showPrescriptionKey = Object.keys(exportSelectorParams).length > 0;
  let prescriptionKey = `label-text__export-option--${scriptType}`;

  if (primaryOnly) {
    prescriptionKey += '--primary';
  }

  return (
    <Modal
      onClose={() => {
        toggleDriveModal(false);
      }}
      show={open}
      size="L">
      <div>
        <p className={`${baseString}__tittle`}>{getMessage('text__success--assign-prescription-tittle')}</p>
        <p className={`${baseString}__hd-txt-confirm`}>
          {getMessage('text__success--assign-prescription-to-device')}
        </p>
        <div className={`${baseString}__table-container`}>
          <div className={`${baseString}__table-column`}>
            <p>{getMessage('text__success--assign-prescription-name')}</p>
            {!showPrescriptionKey
              ? <p>{selectedFormat.scriptName}</p>
              : <p>{getMessage(prescriptionKey, { num: scripts })}</p>
            }
          </div>
          <div className={`${baseString}__table-column`}>
            <p>{getMessage('text__success--assign-prescription-configuration')}</p>
            <p>{selectedDevice.name} + {selectedFormat.deviceLabel}</p>
          </div>
        </div>
      </div>
    </Modal>
  );
};

DriveModal.propTypes = {
  exportSelectorParams: propTypes.shape({
    primaryOnly: propTypes.bool.isRequired,
    scopeType: propTypes.string.isRequired,
    scriptType: propTypes.string.isRequired,
    scripts: propTypes.string.isRequired
  }),
  open: propTypes.bool.isRequired,
  selectedDevice: propTypes.shape({
    id: propTypes.string.isRequired,
    name: propTypes.string.isRequired,
    description: propTypes.string.isRequired
  }).isRequired,
  selectedFormat: propTypes.shape({
    label: propTypes.string.isRequired,
    value: propTypes.string.isRequired,
    scriptName: propTypes.string,
    deviceLabel: propTypes.string
  }).isRequired,
  toggleDriveModal: propTypes.func.isRequired
};

export default connect(
  (state) => {
    const selectedDevice = get(state, 'devices.selected', {
      id : '',
      name : '',
      description: ''
    });
    const selectedFormat = get(state, 'devices.format', {
      scriptName : '',
      deviceLabel: ''
    });
    return {
      selectedDevice,
      selectedFormat,
      exportSelectorParams: state.exportSelector.params || {}
    };
  },
)(DriveModal);
